<template>
  <div class="user-org_uro org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <router-link
        class="help-link"
        :to="{ path: '/help/26'}"
        target="_blank">
        Подробнее о кабинете ответственного от организации в разделе Помощь
      </router-link>
      <h2 class="oam_page-title">Отчеты, аналитика организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <div class="uro_btns-wrap">
        <div class="uro_cols">
          <div class="uro_col">
            <router-link
              class="normal-button"
              :to="`/user/organization/${$route.params.orgId}/objects/confirm`">
              Одобрение новых объектов</router-link>
          </div>
          <div class="uro_col">
            <router-link
              class="normal-button"
              :to="`/user/organization/${$route.params.orgId}/users/list`">
              Работа с пользователями</router-link>
          </div>
          <div class="uro_col">
            <router-link
              class="normal-button"
              :to="`/user/organization/${$route.params.orgId}/claims`">
              Работа с жалобами</router-link>
          </div>
        </div>
      </div>

      <div class="uro_cols">
        <div class="uro_col">

          <org-admin-stat
            :data="usersData"
            :links="[{
              text: 'Отчет о действиях пользователей',
              to: `/user/organization/${$route.params.orgId}/users`
            }]"
            img="/static/grx/icons/stat/users.png"/>

          <org-admin-stat
            :data="dealsData"
            :links="[{
              text: 'Отчет о сделках',
              to: `/user/organization/${$route.params.orgId}/deals`
            }]"
            link-text=""
            :link-to="``"
            img="/static/grx/icons/stat/deals.png"/>

        </div>
        <div class="uro_col">

          <org-admin-stat
            :data="objectsData"
            :links="[{
              text: 'Отчет об объектах',
              to: `/user/organization/${$route.params.orgId}/objects`
            }]"
            img="/static/grx/icons/stat/objects.png"/>

        </div>
      </div>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import PageHeader from '@/components/PageHeader';
import PageFooter from '@/components/PageFooter';
import NavInner from '@/components/NavInner';
import OrgAdminStat from '@/components/org-admin/OrgAdminStat';
import NavUserOrgs from '@/components/org-admin/NavUserOrgs';
import NavUserOrgPage from '@/components/org-admin/NavUserOrgPage';

export default {

  components: {
    PageHeader,
    PageFooter,
    NavInner,
    NavUserOrgs,
    OrgAdminStat,
    NavUserOrgPage,
  },

  data() {
    return {
      usersData: [],
      dealsData: [],
      objectsData: [],
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {

    fetchData() {
      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не указана организация.');
        return;
      }

      axios.get(`organizations/${orgId}/users/statistics`).then((r) => {
        this.usersData = r.data;
      }).catch(() => this.$notify.error('Ошибка при загрузке статистики пользовтелей.'));

      axios.get(`organizations/${orgId}/deals/statistics`).then((r) => {
        this.dealsData = r.data;
      }).catch(() => this.$notify.error('Ошибка при загрузке статистики сделок.'));

      axios.get(`organizations/${orgId}/objects/statistics`).then((r) => {
        this.objectsData = r.data;
      }).catch(() => this.$notify.error('Ошибка при загрузке статистики объектов.'));
    },

  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";

.html_page-form {
  .el-dropdown-link,
  .oa-stat_oat a,
  .user-org_uro {
    color: #fff !important;
  }
}

.user-org_uro {
  .uro_cols {
    margin: 0 -15px;
    .uro_col {
      float: left;
      width: 50%;
      padding: 0 15px;
    }
    @media (max-width: 930px) {
      margin: 0;
      .uro_col {
        float: none;
        width: 100%;
        padding: 0;
      }
    }
  }
  .uro_btns-wrap {
    padding: 0 15px 15px;
    margin-bottom: 15px;
    @include clearfix;
    .uro_cols {
      padding: 15px;
      clear: both;
      @include border-radius(12px);
      background: rgba(0, 0, 0, .20);
      @include clearfix;
      @media(max-width: 500px) {
        padding: 15px 19px;
      }
      .normal-button {
        display: block;
        text-align: center;
      }
    }
    .uro_col {
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrg.vue